var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamaskIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0124 14.5176L17.8588 18.3645L15.5942 17.7537L19.0124 14.5176Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0571157
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5942 17.7537L17.7784 14.802L19.0124 14.5176L15.5942 17.7537Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0571157
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3154 11.6172L19.0127 14.5175L17.7787 14.8019L17.3154 11.6172ZM17.3154 11.6172L18.4075 10.8711L19.0127 14.5175L17.3154 11.6172Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0571157
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9253 9.42555L19.0645 8.15723L18.9085 8.852L15.9253 9.42555ZM18.8092 9.68667L15.9253 9.42555L18.9085 8.852L18.8092 9.68667Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8092 9.68667L18.4073 10.8711L15.9253 9.42554L18.8092 9.68667ZM19.438 8.45099L18.9085 8.852L19.0645 8.15723L19.438 8.45099ZM18.8092 9.68667L18.9085 8.852L19.3292 9.19706L18.8092 9.68667Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1597 16.8164L13.9445 17.0635L15.5944 17.7537L13.1597 16.8164Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.0571157
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4078 10.8713L18.8096 9.68691L19.1548 9.94803L18.4078 10.8713ZM18.4078 10.8713L15.1504 9.8128L15.9257 9.42578L18.4078 10.8713Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7011 5.79395L15.9257 9.42637L15.1504 9.81339L16.7011 5.79395Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0645 8.15805L15.9253 9.42637L16.7006 5.79395L19.0645 8.15805Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7007 5.79393L19.977 5.4209L19.0645 8.15804L16.7007 5.79393Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4078 10.872L17.3157 11.618L15.1504 9.81348L18.4078 10.872Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0571157
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8352 2.80469L19.977 5.42059L16.7007 5.79363L19.8352 2.80469Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8356 2.80469L13.2877 7.50026L13.2026 4.31548L19.8356 2.80469Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.0571157
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 3.93262L13.2025 4.31498L13.2876 7.49976L8.33301 3.93262Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0571157
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1506 9.81339L13.2878 7.50058L16.7012 5.79395L15.1506 9.81339Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.15 9.81348L17.3153 11.618L14.2754 11.9491L15.15 9.81348Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0571157
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2759 11.9484L13.2878 7.5L15.1506 9.81282L14.2759 11.9484Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0571157
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7012 5.79363L13.2878 7.50026L19.8357 2.80469L16.7012 5.79363Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37525 17.6793L9.92121 19.2693L7.81738 17.3809L8.37525 17.6793Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.0571157
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5942 17.7534L16.327 15.0069L17.7784 14.8018L15.5942 17.7534Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0571157
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10645 10.0274L4.78233 7.25293L2.45157 9.69631L2.10645 10.0274Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.0571157
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.779 14.8019L16.3276 15.0071L17.3157 11.6171L17.779 14.8019ZM13.2876 7.49976L10.6827 7.41583L8.33301 3.93262L13.2876 7.49976Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0571157
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3153 11.6172L16.3272 15.0071L16.2468 13.3518L17.3153 11.6172Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0571157
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2754 11.9483L17.3153 11.6172L16.2468 13.3518L14.2754 11.9483Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0571157
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6824 7.41602L13.2873 7.49995L14.2754 11.9484L10.6824 7.41602Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0571157
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6823 7.4162L3.65224 1L8.33267 3.93299L10.6823 7.4162ZM8.32795 18.6539L2.21975 20.519L1 15.9261L8.32795 18.6539Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0571157
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0144 11.1746L5.32153 9.38867L7.25516 9.83165L3.0144 11.1746Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25517 9.83112L5.32153 9.38815L6.3569 5.17285L7.25517 9.83112Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45166 9.69643L5.32138 9.38867L3.01426 11.1746L2.45166 9.69643Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2468 13.3518L15.0555 12.7596L14.2754 11.9482L16.2468 13.3518Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0571157
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45158 9.69618L2.24829 8.6377L5.3213 9.38843L2.45158 9.69618Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8098 14.0934L15.0557 12.7598L16.247 13.352L14.8098 14.0934Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.0571157
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3274 15.0079L14.8098 14.0939L16.247 13.3525L16.3274 15.0079Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0571157
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32114 9.38815L2.24813 8.63741L1.99756 7.74679L5.32114 9.38815ZM6.3565 5.17285L5.32114 9.38815L1.99756 7.74679L6.3565 5.17285ZM6.3565 5.17285L10.6824 7.41572L7.25477 9.83112L6.3565 5.17285Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25488 9.83141L10.6825 7.41602L12.2095 12.0183L7.25488 9.83141ZM12.2095 12.0183L7.47236 11.9204L7.25488 9.83141L12.2095 12.0183Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0571157
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0144 11.1743L7.25516 9.83141L7.47263 11.9204L3.0144 11.1743ZM14.2758 11.9484L12.2098 12.0183L10.6827 7.41602L14.2758 11.9484Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0571157
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0555 12.7596L14.8096 14.0932L14.2754 11.9482L15.0555 12.7596Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0571157
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65259 1L10.6827 7.4162L6.35684 5.17333L3.65259 1Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00073 15.9261L6.92928 15.6836L8.32868 18.6539L1.00073 15.9261Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0571157
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32787 18.6541L6.92847 15.6838L9.84073 15.5439L8.32787 18.6541Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0571157
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8104 14.0938L16.328 15.0077L17.1648 16.9522L14.8104 14.0938ZM7.47296 11.9209L1.00073 15.9263L3.01474 11.1748L7.47296 11.9209ZM6.92928 15.6839L1.00073 15.9263L7.47296 11.9209L6.92928 15.6839ZM14.2761 11.9489L14.6638 13.3384L12.7916 13.4457L14.2761 11.9489ZM12.7916 13.4457L12.2101 12.0188L14.2761 11.9489L12.7916 13.4457Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0571157
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92161 19.2698L8.32837 18.6543L13.8692 19.5729L9.92161 19.2698Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.0571157
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01416 11.1744L2.10645 10.0274L2.45157 9.69629L3.01416 11.1744Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M14.498 18.8921L13.8692 19.5729L8.32837 18.6543L14.498 18.8921Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.0571157
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7959 17.2226L8.32837 18.6541L9.84124 15.5439L14.7959 17.2226Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0571157
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32837 18.6542L14.7959 17.2227L14.498 18.892L8.32837 18.6542Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.0571157
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99766 7.74693L1.78491 4.16113L6.3566 5.17299L1.99766 7.74693ZM2.45152 9.69604L1.82273 9.06654L2.24823 8.63755L2.45152 9.69604Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1501 12.9418L12.2092 12.0186L12.0579 14.2754L11.1501 12.9418Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0571157
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2094 12.0186L11.1504 12.9418L9.60913 13.7299L12.2094 12.0186Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0571157
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1642 16.9521L16.8758 16.7423L14.8098 14.0938L17.1642 16.9521Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0571157
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60933 13.7301L7.47241 11.9209L12.2096 12.0188L9.60933 13.7301Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0571157
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0583 14.2754L12.2096 12.0186L12.7911 13.4454L12.0583 14.2754Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0571157
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61475 8.10145L1.99769 7.74707L2.24826 8.63769L1.61475 8.10145Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0581 14.275L9.60913 13.7294L11.1504 12.9414L12.0581 14.275Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.0571157
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3566 5.17333L1.78491 4.16147L3.65236 1L6.3566 5.17333Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0571157
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M13.869 19.5726L14.129 20.2721L9.92139 19.2695L13.869 19.5726Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.0571157
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84079 15.5434L9.60913 13.7295L12.0581 14.2751L9.84079 15.5434Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0571157
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47241 11.9209L9.60934 13.7301L9.84099 15.544L7.47241 11.9209Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0571157
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7908 13.4457L14.663 13.3384L16.8756 16.7424L12.7908 13.4457ZM7.47215 11.9209L9.84073 15.544L6.92847 15.6839L7.47215 11.9209Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0571157
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7911 13.4453L15.1172 16.9378L12.0583 14.2753L12.7911 13.4453Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0571157
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0583 14.2754L15.1172 16.9379L14.7957 17.2224L12.0583 14.2754Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0571157
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M14.795 17.2223L9.84033 15.5436L12.0576 14.2753L14.795 17.2223ZM16.8752 16.742L15.1165 16.9378L12.7904 13.4453L16.8752 16.742Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0571157
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3388 18.3838L16.5824 19.8806L14.1287 20.2723L17.3388 18.3838ZM14.1287 20.2723L13.8687 19.5728L14.4974 18.8921L14.1287 20.2723Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.0571157
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4979 18.8921L14.9612 18.7102L14.1292 20.2723L14.4979 18.8921ZM14.1292 20.2723L14.9612 18.7102L17.3393 18.3838L14.1292 20.2723Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.0571157
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8759 16.7412L17.4574 17.0909L15.6892 17.3008L16.8759 16.7412Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.0571157
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6895 17.3008L15.1174 16.9371L16.8761 16.7412L15.6895 17.3008ZM15.4862 17.5759L17.6373 17.3194L17.3395 18.3826L15.4862 17.5759Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.0571157
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3389 18.384L14.9609 18.7104L15.4856 17.5773L17.3389 18.384ZM14.9609 18.7104L14.4976 18.8922L14.7954 17.2229L14.9609 18.7104ZM14.7954 17.2229L15.1169 16.9385L15.6889 17.3022L14.7954 17.2229ZM17.4571 17.0924L17.6368 17.3208L15.4856 17.5773L17.4571 17.0924Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.0571157
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4861 17.5767L15.6894 17.3016L17.4576 17.0918L15.4861 17.5767ZM14.7959 17.2224L15.4861 17.5767L14.9614 18.7098L14.7959 17.2224Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.0571157
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6894 17.3019L15.4861 17.577L14.7959 17.2227L15.6894 17.3019Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.0571157
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskIcon);
export default __webpack_public_path__ + "static/media/metamaskIcon.9fce0677398f92f4a03b2632efdb4b64.svg";
export { ForwardRef as ReactComponent };